function initTabbedCollectionsSection(sectionEl) {
    const tablist = sectionEl.querySelector('[role="tablist"]');
    if (!tablist) return;

    const collectionTabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    const collectionPanels = Array.from(sectionEl.querySelectorAll('[role="tabpanel"]'));

    function activateTab(tab) {
        collectionTabs.forEach(function (t) {
            t.classList.remove('active', 'font-semibold', 'bg-[#FFEBF1]', '!border-[#0E0E0E]');
            t.classList.add('bg-[#FFFFFF]', 'font-normal', 'border-[#F3F3F3]');
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('tabindex', '-1');
        });

        collectionPanels.forEach(function (panel) {
            panel.classList.remove('active', '!block', '!opacity-100');
            panel.classList.add('!hidden', '!opacity-0');
            panel.hidden = true;
            panel.setAttribute('tabindex', '-1');
        });

        tab.classList.remove('bg-[#FFFFFF]', 'font-normal', 'border-[#F3F3F3]');
        tab.classList.add('active', 'font-semibold', 'bg-[#FFEBF1]', '!border-[#0E0E0E]');
        tab.setAttribute('aria-selected', 'true');
        tab.setAttribute('tabindex', '0');

        const panelId = tab.getAttribute('aria-controls');
        const activePanel = panelId ? document.getElementById(panelId) : null;

        if (activePanel) {
            activePanel.classList.remove('!hidden', '!opacity-0');
            activePanel.classList.add('active', '!block', '!opacity-100');
            activePanel.hidden = false;
            activePanel.setAttribute('tabindex', '0');
        }
    }

    collectionTabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activateTab(tab);
        });

        tab.addEventListener('keydown', function (e) {
            let newIndex;
            if (e.key === 'ArrowRight') {
                newIndex = (index + 1) % collectionTabs.length;
            } else if (e.key === 'ArrowLeft') {
                newIndex = (index - 1 + collectionTabs.length) % collectionTabs.length;
            } else if (e.key === 'Home') {
                newIndex = 0;
            } else if (e.key === 'End') {
                newIndex = collectionTabs.length - 1;
            } else {
                return;
            }
            e.preventDefault();
            activateTab(collectionTabs[newIndex]);
            collectionTabs[newIndex].focus();
        });
    });
}

function initTabbedCollections() {
    document.querySelectorAll('.shopify-section.tabbed-collections').forEach(initTabbedCollectionsSection);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabbedCollections);
} else {
    initTabbedCollections();
}
